export default function SiteFooter() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#F4F3EE] border-t border-[#D3D9DE]"
    >
      <div className="gp-container py-12 grid grid-cols-12 gap-6 items-start">
        <div className="col-span-12 md:col-span-5">
          <div className="flex items-center gap-2">
            <span aria-hidden className="inline-block h-2 w-2 bg-[#D67229]" />
            <span className="font-display text-xl font-bold tracking-tight text-[#111418]">
              GushPay
            </span>
          </div>
          <p className="mt-4 max-w-sm text-sm text-[#2C333A] leading-relaxed">
            Production accounting for the independent operator. Built in the
            U.S. for the patch.
          </p>
        </div>

        <div className="col-span-6 md:col-span-3">
          <p className="gp-overline">Platform</p>
          <ul className="mt-4 space-y-2 text-sm text-[#2C333A]">
            <li><a href="/#how-it-works" className="hover:text-[#D67229] transition-colors">How it works</a></li>
            <li><a href="/#friction" className="hover:text-[#D67229] transition-colors">Before / after</a></li>
            <li><a href="/#proof" className="hover:text-[#D67229] transition-colors">Why GushPay</a></li>
            <li><a href="/pricing" className="hover:text-[#D67229] transition-colors">Pricing</a></li>
          </ul>
        </div>

        <div className="col-span-6 md:col-span-4">
          <p className="gp-overline">Operator HQ</p>
          <ul className="mt-4 space-y-2 text-sm text-[#2C333A]">
            <li>Midland · Houston · Denver</li>
            <li><a href="mailto:hello@gushpay.com" className="hover:text-[#D67229] transition-colors">hello@gushpay.com</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#D3D9DE]">
        <div className="gp-container py-5 flex flex-col md:flex-row gap-3 items-start md:items-center justify-between">
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#2C333A]">
            © {new Date().getFullYear()} GushPay Energy Software Co.
          </span>
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#8593A1]">
            v 1.0 · Operator preview
          </span>
        </div>
      </div>
    </footer>
  );
}
